/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Avatar, Dropdown, Menu, Space } from "antd";
import Images from "../assets/images";
import { useEffect, useRef, useState } from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { LogoutOutlined, UserOutlined } from '@ant-design/icons';
import { getAuth0ProfileImageUrl, isNotNullUndefined, isValidEmail, toTitleCase } from '../helpers/common';
import { storage } from "../utils/storage";

const Unauthorized = () => {

    const adminEmail = "developer@onviqa.com";
    const [userName, setUserName] = useState<string>("");
    const profileImageUrl = useRef<string>("");
    const { user, logout, error } = useAuth0();
    const [isUnAuthorized, setIsUnAuthorized] = useState(false);
    const [isBlocked, setIsBlocked] = useState(false);

    useEffect(() => {
        const userRoleId = parseInt(localStorage.getItem('userRoleId') || "0");
        const userName = (!isValidEmail(user?.name) ? toTitleCase(user?.name) : toTitleCase(user?.nickname)) ?? localStorage.getItem('userName') ?? "";
        setUserName(userRoleId === 1 ? "Admin" : userName);
        profileImageUrl.current = (isNotNullUndefined(user?.picture)) ? getAuth0ProfileImageUrl(user?.picture) : storage.getLocalProperty("userPicture");
        setIsUnAuthorized(storage.getLocalProperty("isUnAuthorized"));
        setIsBlocked(storage.getLocalProperty("isBlocked"));
    }, [error, user]);


    const profileMenu = (
        <Menu
            items={[
                {
                    key: '1',
                    label: 'Logout',
                    icon: <LogoutOutlined />
                },
            ]}
            onClick={({ key }) => {
                if (key === '1') {
                    logout({ logoutParams: { returnTo: window.location.origin } });
                    window.localStorage.clear();
                }
            }}
        />
    );

    return (
        <div>
            <div className="bg-white shadow-box px-5 sticky top-0 z-10 h-[55px] lg:h-16 leading-[50px] lg:leading-[64px]">
                <div className=''>
                    <div>

                    </div>
                    <div className='user-profile flex justify-between items-center'>
                        <div>
                            <img
                                src={Images.trade}
                                className=" inline-block w-28 lg:w-32"
                                alt="Tradelogo"
                            />
                        </div>

                        <div className="flex items-center">
                            <div className="user-details">
                                <span className='username mr-2.5 text-black text-xs lg:text-base'>{userName}</span>
                            </div>
                            <Dropdown overlay={profileMenu} trigger={['click']}>
                                <a onClick={(e) => e.preventDefault()} >
                                    <Space>
                                        <Avatar icon={
                                            ((profileImageUrl.current ?? "") !== "") ?
                                                < img src={profileImageUrl.current} className='w-5' alt="ProfileImage" />
                                                :
                                                <UserOutlined />
                                        } />
                                    </Space>
                                </a>
                            </Dropdown>
                        </div>
                    </div>
                </div>
            </div>
            <div className="items-center flex justify-center min-h-[calc(100vh-170px)]">
                <div className="lg:w-3/4 2xl:w-1/2 m-2.5 sm:m-5">
                    <div>
                        <h2 className="text-xl sm:text-3xl font-bold text-blue-midnight">
                            {
                                isBlocked ?
                                    "Unauthorized Access"
                                    : isUnAuthorized ? "We are currently reviewing your request." : ""
                            }
                        </h2>
                    </div>
                    <div className="mt-4 sm:mt-10">
                        <div className="bg-white p-4 sm:p-8 lg:p-16 rounded-xl shadow-[0px_5px_15px_rgba(0,0,0,0.35)]">
                            <div className="text-start">
                                <p className="text-[13px] sm:text-base sm:mt-3">Your attempt to access this page has been denied due to the current status of your account. Below are the specific reasons why your access is blocked and instructions on how to resolve the issue:</p>
                                {
                                    (isBlocked) ?
                                        <div>
                                            <p className="font-bold text-blue-midnight text-sm sm:text-lg mt-3">User Blocked</p>
                                            <ul className="mt-2 text-[13px] sm:text-base list-disc pl-5">
                                                <li>Your account is blocked due to policy violations or security concerns.</li>
                                                <li>Contact the Administrator to resolve the issue.</li>
                                                <li>The Administrator will review and unblock your account.</li>
                                                <li>Provide relevant details to speed up the process.</li>
                                            </ul>
                                        </div> :
                                        (isUnAuthorized) ?
                                            <div>
                                                <p className="font-bold text-blue-midnight text-sm sm:text-lg mt-3">User Unauthorized</p>
                                                <ul className="mt-2 text-[13px] sm:text-base list-disc pl-5">
                                                    <li>Your account <span className="font-bold text-blue-midnight text-[13px] sm:text-base">{user?.email}</span> is active.</li>
                                                    <li>No user role has been assigned, which restricts your access to platform features.</li>
                                                    <li>You cannot perform meaningful actions without a role assigned.</li>
                                                    <li>Please contact the Administrator to have a role assigned, restoring your access to the platform.</li>
                                                </ul>
                                            </div>
                                            :
                                            <></>
                                }
                            </div>
                            <div className="mt-5 text-start">
                                <p className="font-bold text-blue-midnight text-sm sm:text-lg">What to Do Next ?</p>
                                <p className="mt-2 text-[13px] sm:text-base">Please contact the
                                    <span className="font-bold text-blue-midnight text-[13px] sm:text-base"><a href={`mailto:${adminEmail}?subject=Request%20Access`}> Administrator</a></span> to restore your access and provide account details for faster resolution.</p>
                            </div>
                            <div>
                                <p className="text-center text-blue-midnight mt-2.5 sm:mt-10 font-semibold text-[13px] sm:text-xl">Thank you for your cooperation. We look forward to working with you!</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default Unauthorized;